<template>
  <van-popup v-model="show" :close-on-click-overlay="false">
    <div class="commonDialogBox">
      <div class="contentBox">
        <div class="title" v-if="titleContent">{{ titleContent }}</div>
        <div class="text" v-if="textContent">{{ textContent }}</div>
        <slot></slot>
      </div>
      <!-- 如果是两个按钮 -->
      <div v-if="rightBtnText" class="bottomBtns">
        <div
          class="leftBtn"
          :class="{ bold: leftBtnBold }"
          :style="{ color: leftBtnColor }"
          @click="clickLeftBtn"
        >
          {{ leftBtnText }}
        </div>
        <div class="centerLine"></div>
        <div
          class="rightBtn"
          :class="{ bold: rightBtnBold }"
          :style="{ color: rightBtnColor }"
          @click="clickRightBtn"
        >
          {{ rightBtnText }}
        </div>
      </div>
      <!-- 否则是一个按钮 -->
      <div v-else class="bottomBtns">
        <div
          class="leftBtn"
          :class="{ bold: leftBtnBold }"
          :style="{ color: leftBtnColor }"
          @click="clickLeftBtn"
        >
          {{ leftBtnText }}
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  model: {
    prop: "show",
    event: "change",
  },
  props: {
    show: Boolean,
    titleContent: String,
    textContent: String,
    showTwoBtn: {
      type: Boolean,
      value: false,
    },
    leftBtnText: String,
    leftBtnColor: String,
    leftBtnBold: {
      type: Boolean,
      value: false,
    },
    rightBtnText: String,
    rightBtnColor: String,
    rightBtnBold: {
      type: Boolean,
      value: false,
    },
  },
  methods: {
    clickLeftBtn: function () {
      this.$emit("clickLeft", false);
    },
    clickRightBtn: function () {
      this.$emit("clickRight");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./commonDialog2.scss";
</style>
